import * as tslib_1 from "tslib";
import * as React from 'react';
import datapoints from '../../lib/datapoints';
import strings from 'owa-strings/owa-mail-strings';
import { logUsage } from 'owa-analytics';
import { openPremiumDashboard } from 'owa-whats-new';
import HeaderCharm from './HeaderCharm';
var styles = require('./Header.scss');
var PremiumOlkCharm = /** @class */ (function (_super) {
    tslib_1.__extends(PremiumOlkCharm, _super);
    function PremiumOlkCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PremiumOlkCharm.prototype.componentDidMount = function () {
        logUsage(datapoints.HeaderPremiumDiamond.datapoint.name);
    };
    PremiumOlkCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm, { ariaLabel: strings.UpgradeMessage, className: styles.launchManagePremium, title: strings.UpgradeMessage, icons: { iconName: "Diamond" /* Diamond */ }, behavior: {
                onClick: this.navigateTo,
                isActive: false,
            } }));
    };
    PremiumOlkCharm.prototype.navigateTo = function () {
        logUsage(datapoints.HeaderPremiumDiamondClicked.datapoint.name);
        openPremiumDashboard();
    };
    return PremiumOlkCharm;
}(React.Component));
export default PremiumOlkCharm;
//# sourceMappingURL=PremiumOlkCharm.js.map